module.exports = __webpack_public_path__ + "static/mvpDev-78f16099c8c11968a918060188a890da.png";